<!-- demo接口样式未调试 -->
<template>
  <div class="conferencePaper">
    <van-list
      v-model="loading"
      :finished="finished"
      :error="error"
      :offset="0"
      :finished-text="articleList.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="lv-list" v-if="loading || articleList.length > 0">
        <LvItem
          class="lv-list-item"
          v-for="item in articleList"
          :hasTip="true"
          :type="item.type"
          :key="item.id"
          :title="item.title"
          :artSummary="item.artSummary"
          :author="item.firstAuthor"
          :otherAuthor="item.articleAuthorList.length > 1 ? ',...' : ''"
          :periodicalName="item.type === 1 ? item.mettingName : item.periodical"
          :periodicalTime="
            item.type === 1
              ? $global.formatDateWithZhToYMD(item.mettingTime)
              : `${item.journalsYear}年第${item.journalsTerm}期`
          "
          @click.native="toDetail(item.id)"
        />
      </div>
      <noneList noneType="lvList" v-else />
    </van-list>
  </div>
</template>
<script>
import LvItem from "@/views/mobileView/components/listItem/lvItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  name: "conferencePaper",
  components: {
    LvItem,
    noneList,
  },
  data() {
    return {
      dropdownValue: "0",
      dropdownoption: [{ text: "全部", value: "0" }],
      params: {
        pageNo: 0,
        pageSize: 20,
        goodsTypeList: [5, 6],
      },
      total: 0,
      articleList: [],
      loading: false,
      finished: false,
      error: false,
    };
  },
  methods: {
    // 触底加载
    onLoad() {
      this.params.pageNo += 1;
      this.getList();
    },
    // 获取列表
    async getList() {
      this.loading = true;
      const resp = await this.$apis.myServe.bookshelf(this.params);
      console.log(resp.data.list, "resprespresprespresp");
      if (resp.resultCode == 200) {
        this.finished = resp.data.list.length < 20;
        resp.data.list.forEach((item) => {
          if (item.articleThesis) {
            this.articleList.push(item.articleThesis);
          }
        });
        this.total = +resp.data.total;
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    // 点击进入详情页
    toDetail(id) {
      this.$router.push({
        name: "thesisDetail",
        query: {
          id: id,
          type: 0,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.conferencePaper {
  padding-bottom: 12px;
  min-height: 100vh;

  .lv-list {
    margin: 12px auto 0;
    width: 351px;
    padding: 0 13px;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    .lv-list-item {
      border-bottom: 1px solid #eee;
      &:last-child {
        border: none;
      }
    }
  }
}
</style>
